import useMemo from '@/util/hook/useMemo';

import PageLayout from '@/component/composite/PageLayout';

import { S } from './style';

import homexinLogoBannerImg from '../../asset/homexinLogoBanner.png';
import lineInstructionImg from '../../asset/lineInstruction.png';
import lineLogoImg from '../../asset/lineLogo.svg';

const ALT_LINK_URL = 'https://lin.ee/RgsOKm2';

const renderLogoBanner = () => (
  <S.LayoutLogoBanner>
    <img src={homexinLogoBannerImg} alt='homexin-logo-banner' />
    <S.BannerTitle>用Home心，最放心</S.BannerTitle>
  </S.LayoutLogoBanner>
);

const renderInstructionSection = () => (
  <S.LayoutSection>
    <S.SectionTitle>第一步：</S.SectionTitle>
    <S.SectionText>點選下方按鈕加入Home心好友 ▼</S.SectionText>
    <S.Gap height={25} />
    <S.SectionTitle>第二步：</S.SectionTitle>
    <S.SectionText>在LINE選單選擇身份，開始派案！</S.SectionText>
    <S.InstructionImg src={lineInstructionImg} alt='line-instruction' />
  </S.LayoutSection>
);

const renderActionButton = ({
  shouldRenderAltLink,
  handleActionButtonClick,
}: {
  shouldRenderAltLink: ViewProps['shouldRenderAltLink'];
  handleActionButtonClick: ViewProps['handleActionButtonClick'];
}) => (
  <S.LayoutActionButton>
    <S.LineButton onClick={handleActionButtonClick}>
      <S.LineImg src={lineLogoImg} alt='line' />
      <S.LineButtonText>開啟LINE</S.LineButtonText>
    </S.LineButton>
    {shouldRenderAltLink ? (
      <S.LinkButton href={ALT_LINK_URL}>
        沒有自動跳到 LINE ?<br />
        點此加入好友
      </S.LinkButton>
    ) : null}
  </S.LayoutActionButton>
);

interface ViewProps {
  // data
  shouldRenderAltLink: boolean;
  // func
  handleActionButtonClick: () => void;
}

export default function View({
  // data
  shouldRenderAltLink,
  // func
  handleActionButtonClick,
}: ViewProps) {
  const logoBanner = useMemo(() => renderLogoBanner(), []);
  const instructionSection = useMemo(() => renderInstructionSection(), []);
  const actionButton = useMemo(
    () => renderActionButton({ shouldRenderAltLink, handleActionButtonClick }),
    [shouldRenderAltLink, handleActionButtonClick],
  );

  return (
    <PageLayout isLoading={false}>
      <S.Layout>
        {logoBanner}
        {instructionSection}
        <S.Gap height={40} />
        {actionButton}
      </S.Layout>
    </PageLayout>
  );
}
